import axios from 'axios'
let user = '/user';
let base = '/base';
let scan = '/scan/api';

export const login = (data)=>{//登录-账号
  return axios.post(`${user}/login`,data)
};
export const loginMobile = (data)=>{//登录-手机号
  return axios.post(`${user}/mobile/login`,data)
};
export const register = (data)=> {//注册
  return axios.post(`${user}/register`,data);
};
export const logout = (data)=>{//退出
  return axios.post(`${user}/logout`,data)
};
export const pass_info = (data)=>{//修改密码
  return axios.post(`${user}/pass_info`,data)
};
export const sms_code = (data)=>{//发送短信验证码
  return axios.post(`${user}/sms_code`,data)
};
export const check_mobile = (data)=>{//验证 手机号(用户绑定新手机号时)
  return axios.post(`${user}/check_mobile`,data)
};
export const check_email = (data)=>{//验证 邮箱(用户绑定新邮箱时)
  return axios.post(`${user}/check_email`,data)
};
export const reset_mobile = (data)=>{//绑定新手机号
  return axios.post(`${user}/reset_mobile`,data)
};
export const set_email = (data)=>{//绑定邮箱
  return axios.post(`${user}/set_email`,data)
};
export const reset_email = (data)=>{//用户修改绑定邮箱
  return axios.post(`${user}/reset_email`,data)
};
export const email_code = (data)=>{//发送邮箱验证码
  return axios.post(`${user}/email_code`,data)
};
export const set_mobile = (data)=>{//绑定手机号
  return axios.post(`${user}/set_mobile`,data)
};
export const contact = (data)=>{//联系我们
  return axios.post(`${base}/contact`,data)
};
export const orders = (data)=>{//新建工单
  return axios.post(`${base}/orders`,data)
};

export const vul_stats = (data)=>{//获取漏洞摘要
  return axios.get(`${scan}/task/vul-stats`,{params:data})
};
export const vul_list = (data)=>{//获取漏洞列表
  return axios.get(`${scan}/task/vul-list`,{params:data})
};
export const vul_detail = (data)=>{//获取漏洞详情
  return axios.get(`${scan}/task/vul-detail`,{params:data})
};


// 漏洞扫描
export const addSite = (data)=>{//添加站点
  return axios.post(`${scan}/site/add`,data)
};
export const delSite = (data)=>{//删除站点
  return axios.post(`${scan}/site/del`,data)
};
export const getSiteList = (data)=>{//得到网站列表
  return axios.get(`${scan}/site/list`,{params:data})
};



// WEBPACK FOOTER //
// ./src/api/api.js